import { render } from "./OnHandComp.vue?vue&type=template&id=03da245e&scoped=true"
import script from "./OnHandComp.vue?vue&type=script&lang=js"
export * from "./OnHandComp.vue?vue&type=script&lang=js"

import "./OnHandComp.vue?vue&type=style&index=0&id=03da245e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03da245e"]])

export default __exports__